import gospun from "./logos/gospun.svg?raw";
import secondwind from "./logos/2nd-wind.svg?raw";
import sneqk from "./logos/sneqk.svg?raw";
import billsole from "./logos/billsole.svg?raw";
import funkfighters from "./logos/funk-fighters.svg?raw";
import bacten from "./logos/bacten.svg?raw";
import tenseconds from "./logos/10seconds.svg?raw";
import americanlegacybrand from "./logos/american-legacy.svg?raw";
import wincord from "./logos/wincord.svg?raw";
import janiebrand from "./logos/janie-brand.svg?raw";
import shoeflys from "./logos/shoeflys.svg?raw";
import kicxgear from "./logos/kicxgear.svg?raw";
import demand2win from "./logos/demand2win.svg?raw";

/** The various options for the brands navbar. */
export interface HbiBrandsNavBarOptions {
  /** The css selector of the element in which to inject the navbar in. */
  selector: string;
}

export default class HbiBrandsNavBar {
  private readonly options: HbiBrandsNavBarOptions;
  
  /** Creates a navbar with the specified options */
  constructor(options: HbiBrandsNavBarOptions) {
    this.options = options;
    this.loadWebComponent();
    this.setStyles();
  }

  /** Loads the navbar and replaces the placeholder element */
  public load() {
    const element = document.querySelector(this.options.selector) as HTMLElement;
    if (element == null) {
      console.error(`Element with selector "${this.options.selector}" not found.`);
      return;
    }

    element.innerHTML = `
      <nvq-brands-navbar>
        <a href="https://gospun.com/" target="_blank" alt="gospun" title="gospun" rel="noopener">
          ${gospun}
        </a>
        <a href="https://www.sneqk.com/" target="_blank" alt="sneqk" title="Sneqk" rel="noopener">
          ${sneqk}
        </a>
        <a href="https://billsole.com/" target="_blank" alt="billsole" title="Billsole" rel="noopener">
          ${billsole}
        </a>
        <a href="https://funkfighters.com/" target="_blank" alt="funkfighters" title="Funk Fighters" rel="noopener">
          ${funkfighters}
        </a>
        <a href="https://www.bacten.com" target="_blank" alt="bacten" title="Bacten" rel="noopener">
          ${bacten}
        </a>
        <a href="https://www.tenseconds.com/" target="_blank" alt="tenseconds" title="Ten Seconds" rel="noopener">
          ${tenseconds}
        </a>
        <a href="https://americanlegacybrand.com/" target="_blank" alt="American Legacy Brand" title="American Legacy Brand" rel="noopener">
          ${americanlegacybrand}
        </a>
        <a href="https://www.wincord.com/" target="_blank" alt="wincord" title="Wincord" rel="noopener">
          ${wincord}
        </a>
        <a href="https://janiebrand.com/" target="_blank" alt="janiebrand" title="Janie Brand" rel="noopener">
          ${janiebrand}
        </a>
        <a href="https://2ndwind.com/" alt="2ndwind" title="2nd Wind" rel="noopener">
          ${secondwind}
        </a>
        <a href="https://shoeflys.com/" alt="shoeflys" title="Shoeflys" rel="noopener">
          ${shoeflys}
        </a>
        <a href="https://kicxgear.com/" alt="kikx gear" title="Kickx Gear" rel="noopener">
          ${kicxgear}
        </a>
        <a href="https://demand2win.com/" alt="demand2win" title="Demand 2 Win" rel="noopener">
          ${demand2win}
      </nvq-brands-navbar>
    `;
  }

  private loadWebComponent() {
    import("https://unpkg.com/@nvisionative/nvq-brands-nav-bar@next").then(() => {
      console.log("Brands navbar loaded");
    }).catch((error) => {
      console.error("Error loading brands navbar:", error);
    });
  }

  private setStyles() {
    const styles = document.createElement("style");
    styles.innerHTML = `
      nvq-brands-navbar a svg {
        fill: white;
      }
      nvq-brands-navbar a:hover svg,
      nvq-brands-navbar a:focus svg {
        fill: #AAA;
      }
    `;
    document.head.appendChild(styles);
  }
}

(window as any).HbiBrandsNavBar = HbiBrandsNavBar;